module.exports = __webpack_public_path__ + "static/media/spec.df9dfff0.jpeg";